import * as types from './actionTypes';

export function addNotificationSuccess(notificationObject) {
  return { type: types.ADD_NOTIFICATION_SUCCESS, notificationObject };
}

export function addNotification(notificationObject) {
  return function(dispatch) {
    dispatch(addNotificationSuccess(notificationObject));
  };
}



// WEBPACK FOOTER //
// ./library/app/actions/notificationActions.js